// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"c2795765","839":"318c9aab"}[chunkId] + ".chunk.js";
};